export const CATEGORIES_TRANSLATE = {
    categories: {
        breadcrumbName: "Categorías",
        messages: {
            create: "Categoría agregada exitosamente",
            update: "Categoría actualizada exitosamente",
            delete: "Categoría desactivada exitosamente",
            recover: "Categoría restaurada exitosamente"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Nombre",
                    complaintType: "Canal de denuncia"
                }
            },
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Ingrese el ID",
                        url: "id"
                    },
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre",
                        url: "name"
                    },
                    email: {
                        label: "Correo electrónico",
                        placeholder: "Ingrese el correo electrónico",
                        url: "email"
                    },
                    complaintType: {
                        label: "Canal de denuncia",
                        placeholder: "Seleccione el canal de denuncia",
                        url: "complaint-channel"
                    },
                    active: {
                        label: "Estado",
                        placeholder: "Seleccione el estado",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Desactivar categoría",
                    body: "¿Está seguro de que desea desactivar la categoría con ID {{id}}?",
                    save: {
                        text: "Sí, desactivar"
                    },
                    back: {
                        text: "Volver"
                    },
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre"
                    },
                    complaintType: {
                        label: "Canal de denuncia",
                        placeholder: "Seleccione el canal de denuncia"
                    },
                }
            }
        },
        dictionaries: {
            breadcrumb: "Diccionarios",
            messages: {
                create: "Diccionario creado exitosamente",
                update: "Diccionario actualizado exitosamente",
                delete: "Diccionario eliminado exitosamente",
                recover: "Diccionario restaurado exitosamente"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Idioma",
                        name: "Nombre"
                    }
                },
                dialog: {
                    delete: {
                        title: "Eliminar diccionario",
                        body: "¿Está seguro de que desea eliminar el diccionario con ID {{id}}?",
                        save: {
                            text: "Sí, eliminar"
                        },
                        back: {
                            text: "Volver"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Idioma",
                            placeholder: "Seleccione el idioma"
                        },
                        name: {
                            label: "Nombre",
                            placeholder: "Ingrese el nombre"
                        }
                    }
                }
            }
        }
    }
}
